module.exports = __webpack_public_path__ + "e9a99e8527b6508803aee38d52e45daf.svg";